// Eintragskarte mit runden Aktionsknöpfen (Prototyp Buchungslinks/Selbstauskunft-Links).
import type { ReactNode } from 'react';
import type { Icon } from '@phosphor-icons/react';
import { ABSCHNITT, ABSCHNITT_FARBE, FORM, GLANZ, RUND_KNOPF, type AbschnittFarbe } from './form-stil';

export interface FormEintragAktion { label: string; icon: Icon; onClick: () => void; farbe?: string }

export function FormEintragKarte({ icon: I, farbe, titel, chip, unter, aktionen, gedimmt }: {
  icon: Icon;
  farbe: AbschnittFarbe;
  titel: string;
  chip?: ReactNode;
  unter?: string;
  aktionen: readonly FormEintragAktion[];
  gedimmt?: boolean;
}) {
  const f = ABSCHNITT_FARBE[farbe];
  return (
    <div className="pf-rise relative flex shrink-0 items-center overflow-hidden" style={{
      gap: 10, padding: 12, borderRadius: ABSCHNITT.radius, opacity: gedimmt ? 0.6 : 1, boxShadow: ABSCHNITT.schatten,
      background: `linear-gradient(165deg,${f.toenung},rgba(255,255,255,0.035) 55%,rgba(255,255,255,0.02))`,
    }}>
      <I aria-hidden size={100} weight="fill" className="pointer-events-none absolute" style={{ right: -14, bottom: -24, color: f.akzent, opacity: 0.07, transform: 'rotate(-14deg)' }} />
      <span aria-hidden className="relative flex shrink-0 items-center justify-center overflow-hidden" style={{
        width: 40, height: 40, borderRadius: 12, background: f.verlauf, boxShadow: `inset 0 1px 1px rgba(255,255,255,0.5),0 8px 16px -8px ${f.akzent}`,
      }}>
        <span className="absolute inset-0" style={{ background: GLANZ }} />
        <I size={19} weight="bold" color="#fff" className="relative" />
      </span>
      <div className="relative flex min-w-0 flex-1 flex-col" style={{ gap: 2 }}>
        <div className="flex flex-wrap items-center" style={{ gap: 6 }}>
          <span className="min-w-0 truncate" style={{ fontSize: 14.5, fontWeight: 800, color: FORM.text }}>{titel}</span>
          {chip}
        </div>
        {unter && <span style={{ fontSize: 12, fontWeight: 600, color: FORM.text2 }}>{unter}</span>}
      </div>
      <div className="relative flex shrink-0" style={{ gap: 6 }}>
        {aktionen.map(a => {
          const A = a.icon;
          return (
            <button key={a.label} type="button" onClick={a.onClick} aria-label={a.label} data-tip={a.label}
              className="pf-knopf flex cursor-pointer items-center justify-center rounded-full border-none"
              style={{ width: 34, height: 34, background: RUND_KNOPF.flaeche, boxShadow: RUND_KNOPF.ring, color: a.farbe ?? FORM.text }}>
              <A size={15} weight="bold" />
            </button>
          );
        })}
      </div>
    </div>
  );
}
